import { DownloadReportsRepository } from "@adapters/repositories/Reports/common/downloadrepo";
import { http, accountDetails } from "../../../../../mainDi/webDi";
import { EdelFileSaver } from "@domains/utils/FIleSaver";
export var downloadReportsRepo = new DownloadReportsRepository(http, new EdelFileSaver(), accountDetails);
